import { useContext, useEffect, useState } from "react";
import { AuthContext } from "../AuthContext";
import { Header, Image, Table } from "semantic-ui-react";
import EventCalendar from "./EventCalendar";
import { useLazyQuery } from "@apollo/client";
const Home = (props) => {
  const { loginContext, themeColor } = useContext(AuthContext);
  const { handleChangeMenu, jobId } = props;
  const isAdmin = loginContext.role === "Admin";
  const [downloadsList, setDownloads] = useState([]);

  return (
    <div
      style={{
        display: "flex",
        width: "100%",
        height: "calc(100% - 50px)",
        position: "absolute",
        backgroundColor: "#BFBFBF",
        top: "50px",
      }}
    >
      <div
        style={{
          backgroundColor: "#FFFFFF",
          padding: "20px",
          zIndex: "1",
          width: "100%",
        }}
      >
        <EventCalendar handleChangeMenu={handleChangeMenu} jobId={jobId} />
      </div>
    </div>
  );
};
export default Home;
